import {CustomersActionTypes} from ".";
import CustomersService from "../../services/CustomersService";
import {Customer} from "../../models/Customer";
import {AppStore} from "../../desktop";
import {TabsActionTypes} from "../tabs";
import {Contact} from "../../models/Contact";
import {CustomerFinances} from "../../models/CustomerFinances";

export const actionCustomerFetchAll = () => {
	AppStore.dispatch({type: CustomersActionTypes.FETCH_ALL_REQUEST, payload: null})
}

export const actionCustomerFetchAllCompleted = (customers: Customer[]) => {
	AppStore.dispatch({type: CustomersActionTypes.FETCH_ALL_COMPLETED, payload: customers})
}

export const actionCustomerFetch = (customer: Customer) => {
	AppStore.dispatch({type: CustomersActionTypes.FETCH_ONE_REQUEST, payload: customer})
}

export const actionCustomerFetchCompleted = (customer: Customer) => {
	AppStore.dispatch({type: CustomersActionTypes.FETCH_ONE_COMPLETED, payload: customer})
	AppStore.dispatch({type: TabsActionTypes.SET_TAB_ITEM, payload: customer})
}

export const actionCustomerSave = (customer: Customer) => {
	AppStore.dispatch({type: CustomersActionTypes.SAVE_REQUEST, payload: customer})
}

export const actionCustomerSaveCompleted = (customer: Customer) => {
	AppStore.dispatch({type: CustomersActionTypes.SAVE_COMPLETED, payload: customer})
}

export const actionDeleteCustomer = (customer: Customer) => {
	AppStore.dispatch({type: CustomersActionTypes.DELETE_REQUEST, payload: customer})
}

export const actionDeleteCustomers = (customers: Customer[]) => {
	AppStore.dispatch({type: CustomersActionTypes.DELETE_MULTIPLE_REQUEST, payload: customers})
}

export const actionContactSave = (contact: Contact, index: number) => {
	AppStore.dispatch({type: CustomersActionTypes.SAVE_CONTACT_REQUEST, payload: {contact: contact, index: index}})
}

export const actionContactSaveCompleted = (contact: Contact, index: number) => {
	AppStore.dispatch({type: CustomersActionTypes.SAVE_CONTACT_COMPLETED, payload: {contact: contact, index: index}})
}

export const actionContactDelete = (contact: Contact) => {
	AppStore.dispatch({type: CustomersActionTypes.DELETE_CONTACT_REQUEST, payload: contact})
}

export const actionContactDeleteCompleted = (contact: Contact) => {
	AppStore.dispatch({type: CustomersActionTypes.DELETE_CONTACT_COMPLETED, payload: contact})
}

export const actionCustomerFinances = (finances: CustomerFinances[]) => {
	AppStore.dispatch({type: CustomersActionTypes.FETCH_FINANCES, payload: finances})
}

export const actionCustomerFinancesDelete = (finances: CustomerFinances[]) => {
	AppStore.dispatch({type: CustomersActionTypes.DELETE_FINANCES, payload: finances})
}
